import React from 'react';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import StairsIcon from '@mui/icons-material/Stairs';
import { ParameterValueOptionModel } from './ParameterValueOptionModel';

export enum EdgeType {
	Bezier = 'bezier',
	SmoothStep = 'smoothstep',
	Straight = 'straight',
	Step = 'step',
	Default = 'default',
}

export function getEdgeTypeIcon(type: EdgeType): JSX.Element {
	switch (type) {
		case EdgeType.Bezier:
			return <ShowChartIcon fontSize="small" />;
		case EdgeType.SmoothStep:
			return <StairsIcon fontSize="small" />;
		case EdgeType.Straight:
			return <LinearScaleIcon fontSize="small" />;
		case EdgeType.Step:
			return <StairsIcon fontSize="small" />;
		default:
			return <ShowChartIcon fontSize="small" />;
	}
}

export const EDGE_TYPE_OPTIONS: ParameterValueOptionModel<EdgeType>[] = [
	{ value: EdgeType.Default, label: 'Default', icon: () => getEdgeTypeIcon(EdgeType.Default) },
	{ value: EdgeType.Bezier, label: 'Bezier', icon: () => getEdgeTypeIcon(EdgeType.Bezier) },
	{ value: EdgeType.SmoothStep, label: 'Smooth Step', icon: () => getEdgeTypeIcon(EdgeType.SmoothStep) },
	{ value: EdgeType.Straight, label: 'Straight', icon: () => getEdgeTypeIcon(EdgeType.Straight) },
	{ value: EdgeType.Step, label: 'Step', icon: () => getEdgeTypeIcon(EdgeType.Step) },
];

export function getEdgeTypeName(type: EdgeType): string {
	const option = EDGE_TYPE_OPTIONS.find((opt) => opt.value === type);
	return option?.label ?? 'Default';
}
